import { useStaliasate, useRef,useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { motion } from "framer-motion";
import { ShieldCheck, ArrowLeft } from 'lucide-react';import { toast } from 'react-toastify';import styles from './OtpPage.module.css';
// import { getTranslation as t } from '../Helpers/Translate';
import axios from 'axios';
import { chargeApi, checkUserApi, verifyOtpApi } from '../http/api';
import { v4 as uuidv4 } from 'uuid';
import { useTranslate } from '../components/UseTranslate';
import {LanguageSwitcher} from '../components/LanguageSwitcher'


export function OtpPage() {
  const [otp, setOtp] = useState(['', '', '', '']);
  const inputRefs = useRef([]);
  const navigate = useNavigate();
    const ext_ref = localStorage.getItem('ext_ref')|| uuidv4();
    const { t } = useTranslate();



    const location = useLocation();
    const msisdn = location?.state?.msisdn
  console.log(location.state,'------------------')

  const handleChange = (index, value) => {
    if (!/^\d*$/.test(value)) return;
    
    const newOtp = [...otp];
    newOtp[index] = value.slice(0, 1);
    setOtp(newOtp);

    // Auto-focus next input
    if (value && index < 5) {
      inputRefs.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    }
  };

 const handleSubmit = async(e) => {
  e.preventDefault();

  const otpValue = otp.join('');

  if (otpValue.length < 4) {
    toast.error('Please enter a valid OTP.');
    return;
  }

  console.log('OTP Entered:', otpValue);

  try{
    const data ={
      msisdn:msisdn,
      otp:otpValue,
      ext_ref:ext_ref
    }

    const resp = await axios.post(verifyOtpApi,data);
    console.log(resp,'response--------------');
    const alias = resp?.data?.alias;
    console.log(alias,'alias--------------')

    if(resp.data.status == 1){
      toast.success(t(resp.data.message) || t('Otp Verified Successfully'))
    }

    const checkResponse = await axios.post(checkUserApi, { alias:alias });
    if(checkResponse?.data?.status == '2'){
      //user not found 
      localStorage.setItem('alias', alias);
      navigate('/pack',{state:{msisdn:msisdn,alias:alias}})
    }
    else if(checkResponse?.data?.status == '0'){
      //request payment 
      localStorage.setItem('alias', alias);
      navigate('/')
    }
    else{
      const subscription_id = checkResponse?.data?.result[0].subscription_id;
      localStorage.setItem('alias', alias);

      const data ={
        subscription_id:subscription_id,
        alias:alias,
        msisdn:checkResponse?.data?.result[0]?.msisdn,
        ext_ref:checkResponse?.data?.result[0]?.ext_ref,
        pack_type:checkResponse?.data?.result[0]?.pack_type,
        purchase:checkResponse?.data?.result[0]?.purchase,
        price:checkResponse?.data?.result[0]?.price,
        currency:checkResponse?.data?.result[0]?.currency,
      }

      const chargeResponse = await axios.post(chargeApi,data);

      if(chargeResponse?.data?.payment_status == '1'){
        //payment success
        localStorage.setItem('alias', alias);
        navigate('/')
      }
      else{
        //payment failed
        toast.error(chargeResponse?.data?.err || t('Payment Failed!!'))
        navigate('/subscribe')
      }
    }
  }
  catch(err){
    console.log(err,'errr--------------')
    if(err.response?.data?.status == 0){
      toast.error(err?.response?.data?.err || t('OTP Verification Failed!!'))
      navigate('/subscribe')
    }
    else if(err.response?.data?.payment_status == 0){
      toast.error(err?.response?.data?.err || t('Payment Failed!!'))
      toast.error(t('Please top up your account to continue using the service.'))
      navigate('/subscribe');
    }
    else{
      toast.error(err?.response?.data?.message || t('OTP Verification Failed!!'))
      navigate('/subscribe')
    }
  }

  // navigate('/subscribe');
};
  const handleResend = () => {
    setOtp(['', '', '', '', '', '']);
    inputRefs.current[0]?.focus();
    console.log('Resending OTP...');
    toast.success('A new OTP has been sent to your mobile number.');
  };

  const handleBack = () => {
    navigate(-1);
  };

  const otpComplete = otp.filter(d => d).length >= 4;

  return (
    <div className={styles.container}>
      <button className={styles.backBtn} onClick={handleBack}>
        <ArrowLeft className={styles.arrowIcon} />
      </button>

      <div className={styles.content}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className={styles.card}
        >
          <div className={styles.header}>
            <motion.div
              initial={{ scale: 0, rotate: -180 }}
              animate={{ scale: 1, rotate: 0 }}
              transition={{ type: 'spring', stiffness: 100, delay: 0.2 }}
              className={styles.iconWrapper}
            >
              <ShieldCheck className={styles.icon} />
            </motion.div>

            <h1 className={styles.title}>{t('Verify Your Number')}</h1>
            <p className={styles.subtitle}>{t('Enter the verification code sent to your mobile number')}</p>
          </div>

          <form onSubmit={handleSubmit} className={styles.form}>
            <div className={styles.otpInputsWrapper}>
              <label className={styles.label}>{t('One-Time Password (OTP)')}</label>
              <div className={styles.otpInputs}>
                {otp.map((digit, index) => (
                  <motion.input
                    key={index}
                    ref={(el) => (inputRefs.current[index] = el)}
                    type="text"
                    inputMode="numeric"
                    maxLength="1"
                    value={digit}
                    onChange={(e) => handleChange(index, e.target.value)}
                    onKeyDown={(e) => handleKeyDown(index, e)}
                    className={`${styles.otpInput} ${digit ? styles.otpInputFilled : ''}`}
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ delay: index * 0.05 }}
                  />
                ))}
              </div>
            </div>

            <motion.button
              type="submit"
              disabled={!otpComplete}
              whileHover={otpComplete ? { scale: 1.02 } : {}}
              whileTap={otpComplete ? { scale: 0.98 } : {}}
              className={`${styles.verifyBtn} ${otpComplete ? styles.verifyBtnActive : ''}`}
            >
              {t('Verify OTP')}
            </motion.button>
          </form>

          <div className={styles.resendSection}>
            {/* <p className={styles.resendText}>
              {t("Didn't receive the code?")}{' '}
              <button
                type="button"
                onClick={handleResend}
                className={styles.resendBtn}
              >
                {t('Resend OTP')}
              </button>
            </p> */}
            <p className={styles.timerText}>{t('Resend available in')} 30s</p>
          </div>
        </motion.div>
      </div>
      <LanguageSwitcher/>
    </div>
  );
}
   